import { FunctionalComponent, h } from "preact";
import TextEffects from "../../effects/textEffects";

const SystemMessage: FunctionalComponent<{
  msgText: string;
  time: string;
  msgID: string;
  disableEffects?: number[];
  tickCallback: () => void;
}> = ({ msgText, time, msgID, disableEffects, tickCallback }) => {
  return (
    <div className="humanTakeover chatMsg">
      <p id={`m_${msgID}`}>
        <TextEffects
          disableEffects={disableEffects}
          msgText={msgText}
          tickCallback={tickCallback}
        />
      </p>
    </div>
  );
};

export default SystemMessage;
